import { addSuggestionPillInternal } from '../actions/internalActions';
import { addSuggestionPill, onSearchTextChanged } from '../actions/publicActions';
import datapoints from '../datapoints';
import getCanAddMoreSuggestionPills from '../selectors/getCanAddMoreSuggestionPills';
import { getStore } from '../store/store';
import { logUsage } from 'owa-analytics';
import { SuggestionKind } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
export default orchestrator(addSuggestionPill, function (actionMessage) {
    var suggestionPill = actionMessage.suggestionPill;
    /**
     * If payload is invalid, or if no more pills can be added to the search
     * box, bail.
     */
    if (!suggestionPill || !getCanAddMoreSuggestionPills()) {
        return;
    }
    var searchStore = getStore();
    var pillId = suggestionPill.ReferenceId;
    /**
     * Only add suggestion to collection of suggestion pills if it hasn't already
     * been added.
     *
     * VSTS [29915]: Able to add two of the same persona pills to search box
     */
    if (searchStore.suggestionPillIds.indexOf(pillId) === -1) {
        /**
         * Add the suggestion pill to the collection, as well as adding its ID to
         * the array of IDs to maintain order.
         */
        addSuggestionPillInternal(suggestionPill);
        // Clear search text (since suggestion pill was picked based on search text).
        if (actionMessage.suggestionSelcted) {
            onSearchTextChanged('');
        }
        // Log CTQ that a suggestion pill was added to the search box.
        logUsage(datapoints.AddSuggestionPillAction.datapoint.name, datapoints.AddSuggestionPillAction.datapoint.customData(SuggestionKind[suggestionPill.kind]));
    }
});
//# sourceMappingURL=addSuggestionPillOrchestrator.js.map